import { StyledPlaySimple } from './style';
import { Box } from '@mui/system';
import { Stack } from '@mui/material';
import { RibbonBadge } from '../../Badge/RibbonBadge/RibbonBadge';
import {
    EBadgePosition,
    EBadgeType,
    EBundlesInternalViewModel,
    EProductPriority
} from '../../Helper/enums';
import { PlaySimpleSaleBadge } from '../../Badge/Sale/PlaySimpleSaleBadge';
import BundleSubProduct from '../../Products/sub';
import BundlePrice from '../BundlePrice';
import { BundleProps } from '../types';
import { useEffect, useState } from 'react';
import { BadgeData } from '../../Badge/types';

function Bundle({
    productList,
    badges = [],
    backgroundSrc,
    salePercentage = 0,
    salePercentageDisplayType,
    price
}: BundleProps) {
    const [ribbonBadge, setRibbonBadge] = useState<any>(null);
    const mainProduct = productList.find(product => product?.priority === EProductPriority.MAIN);
    const subProducts = productList.filter(product => product?.priority === EProductPriority.SUB)
    useEffect(() => {
        if (badges.length > 0) {
            const foundRibbon = badges.find((badge: BadgeData) => {
                const badgeType = badge.badge ? badge.badge.type : badge.type;
                return badgeType === EBadgeType.RIBBON;
            });

            setRibbonBadge(foundRibbon?.badge?.ribbon || foundRibbon?.ribbon);
        }
    }, [badges]);

    return (
        <StyledPlaySimple
            className="playSimple-bundle"
            backgroundSrc={backgroundSrc}
        >
            <Box className={'playSimple-bundle__header'}>
                {ribbonBadge && (
                    <>
                        <RibbonBadge
                            text={ribbonBadge.text}
                            textColor={ribbonBadge.textColor}
                            backgroundColor={ribbonBadge.backgroundColor}
                            position={EBadgePosition.CENTER}
                            viewModel={EBundlesInternalViewModel.PLAY_SIMPLE}
                        />
                        <div className="playSimple-bundle__header__ribbonBadge-arrow"></div>
                    </>
                )}
                {salePercentage > 0 && (
                    <>
                        <div className="playSimple-bundle__header__saleBadge"></div>
                        <PlaySimpleSaleBadge
                            salePercentage={salePercentage}
                            amountAfterSale={price.price}
                            salePercentageDisplayType={
                                salePercentageDisplayType
                            }
                        />
                    </>
                )}
            </Box>
            <Box className={'playSimple-bundle__products-container'}>
                {productList?.length > 0 && (
                    <>
                        <div
                            className={
                                'playSimple-bundle__product-quantity-section'
                            }
                        >
                            {mainProduct && (
                                <Box className="playSimple-bundle__main-quantity">
                                    {mainProduct.images?.productPrefix && (
                                        <img
                                            src={
                                                mainProduct.images.productPrefix
                                            }
                                            alt="coin"
                                        />
                                    )}
                                    <div className="playSimple-bundle__main-quantity-text">
                                        {mainProduct.quantityDisplay}
                                        <div className="playSimple-bundle__main-quantity-text__stroked">
                                            {salePercentage > 0 &&
                                                mainProduct.strokedSaleQuantity}
                                        </div>
                                    </div>
                                </Box>
                            )}

                            <Box className="playSimple-bundle__sub-products-quantity">
                                {subProducts &&
                                    subProducts.map((product, i) => (
                                        <Stack
                                            justifyContent="center"
                                            alignItems="center"
                                        >
                                            <BundleSubProduct
                                                key={i}
                                                textFontColorHex={
                                                    product.textFontColorHex
                                                }
                                                quantityDisplay={
                                                    product.quantityDisplay
                                                }
                                                images={product.images}
                                                quantity={product.quantity}
                                                name={product.name}
                                            />
                                        </Stack>
                                    ))}
                            </Box>
                        </div>
                        {mainProduct && (
                            <div
                                className={'playSimple-bundle__product-img-section'}
                            >
                                <img
                                    src={mainProduct?.images.product}
                                    alt="product"
                                />
                            </div>
                        )}
                    </>
                )}
            </Box>
            <Box className={'playSimple-bundle__bundle-price'}>
                {/* {(salePercentage > 0 && productList.length > 0) && (
                   <Box className="text-container-stroked">
                       {productList[0].strokedSaleQuantity}
                    </Box>
                )} */}
                <BundlePrice
                    price={price}
                    height={'40px'}
                    type="playSimple"
                    borderRadius={'30px'}
                    whiteStripe={false}
                />
            </Box>
        </StyledPlaySimple>
    );
}

export default Bundle;
